module.exports = __webpack_public_path__ + "img/Harry.1aa9065d.png";